import React from 'react';
import { Tv, Camera, MapPin, Ticket } from 'lucide-react';

const EntertainmentSection = ({ 
  formData, 
  handleInputChange, 
  errors
}) => {
  // Описания уровней развлечений
  const entertainmentOptions = {
    'minimal': {
      name: 'Минимальный',
      description: 'Основные бесплатные достопримечательности и активности. Около 500 ₽ на человека в день.',
      icon: <MapPin className="w-5 h-5 text-blue-500" />
    },
    'moderate': {
      name: 'Средний',
      description: 'Несколько платных музеев, развлечений и мероприятий. Около 1200 ₽ на человека в день.',
      icon: <Camera className="w-5 h-5 text-indigo-500" />
    },
    'extensive': {
      name: 'Максимальный',
      description: 'Полная программа: экскурсии, активности, мероприятия и развлечения. От 2500 ₽ на человека в день.',
      icon: <Ticket className="w-5 h-5 text-pink-500" />
    }
  };

  // Получить информацию о текущем выбранном уровне развлечений
  const currentEntertainmentOption = entertainmentOptions[formData.entertainmentLevel] || entertainmentOptions.moderate;

  return (
    <div className="mb-6 bg-indigo-50 dark:bg-indigo-900/20 p-4 rounded-lg border border-indigo-200 dark:border-indigo-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Tv className="w-5 h-5 text-indigo-500 mr-2" />
        Развлечения
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Уровень развлечений */}
        <div className="col-span-full">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Уровень развлечений
          </label>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
            {Object.entries(entertainmentOptions).map(([key, option]) => (
              <label 
                key={key}
                className={`
                  flex flex-col items-center justify-center p-3 rounded-lg border
                  ${formData.entertainmentLevel === key 
                    ? 'bg-indigo-100 border-indigo-300 text-indigo-700 dark:bg-indigo-900/40 dark:border-indigo-700 dark:text-indigo-300'
                    : 'bg-white border-gray-200 hover:bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:hover:bg-gray-650'}
                  transition-colors cursor-pointer
                `}
              >
                <input
                  type="radio"
                  name="entertainmentLevel"
                  value={key}
                  checked={formData.entertainmentLevel === key}
                  onChange={handleInputChange}
                  className="sr-only"
                />
                <div className="mb-2">
                  {option.icon}
                </div>
                <span className="text-sm font-medium">{option.name}</span>
              </label>
            ))}
          </div>
          {errors.entertainmentLevel && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.entertainmentLevel}
            </p>
          )}
        </div>

        {/* Музеи и достопримечательности */}
        <div>
          <label className="flex items-center">
            <input
              type="checkbox"
              name="includeMuseumsAndAttractions"
              checked={formData.includeMuseumsAndAttractions}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <div className="ml-2">
              <span className="text-sm text-gray-700 dark:text-gray-300">
                Музеи и достопримечательности
              </span>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                ~800 ₽ на человека в день
              </p>
            </div>
          </label>
        </div>

        {/* Экскурсии с гидом */}
        <div>
          <label className="flex items-center">
            <input
              type="checkbox"
              name="includeGuidedTours"
              checked={formData.includeGuidedTours}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <div className="ml-2">
              <span className="text-sm text-gray-700 dark:text-gray-300">
                Экскурсии с гидом
              </span>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                ~2000 ₽ на человека (каждые 3 дня)
              </p>
            </div>
          </label>
        </div>
      </div>

      {/* Информация о выбранном уровне развлечений */}
      <div className="mt-4 bg-white dark:bg-gray-700 p-3 rounded-lg border border-indigo-100 dark:border-indigo-800">
        <div className="flex items-start">
          {currentEntertainmentOption.icon}
          <div className="ml-3">
            <h4 className="text-sm font-medium text-gray-900 dark:text-white">
              {currentEntertainmentOption.name} уровень
            </h4>
            <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">
              {currentEntertainmentOption.description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EntertainmentSection;